// extracted by mini-css-extract-plugin
export default {"contacts_form_input":"input_contacts_form_input__sOkYI"};